export function isValidEan(ean: string | number | null | undefined): boolean {
	if (ean == null) {
		return false;
	}

	const normalized = String(ean).trim();
	if (!/^\d{13}$/.test(normalized)) {
		return false;
	}

	const digits = normalized.split('').map(Number);
	const sum = digits
		.slice(0, 12)
		.reduce((acc, digit, index) => acc + digit * (index % 2 === 0 ? 1 : 3), 0);
	const checkDigit = (10 - (sum % 10)) % 10;

	return checkDigit === digits[12];
}
